import React from "react"

import { DEFAULT_CURRENCY, formatWholeStripeAmount, useBounceGlobalValues, useTranslation } from "@bounce/i18n"

import { Packages } from "./Packages"
import { AppBannerTertiary } from "../../../../../components/LuggageStorage/AppBanner/AppBannerTertiary/AppBannerTertiary"
import { Product } from "@/types"

export type ProductBannerProps = {
  showImage?: boolean
  product?: Product
  className?: string
}

export const ProductBanner = ({
  className,
  product = Product.LuggageStorage,
  showImage = true,
}: ProductBannerProps) => {
  const { t, i18n } = useTranslation()
  const { numCities } = useBounceGlobalValues()

  if (product === Product.PackageAcceptance) {
    return <Packages showImage={showImage} className={className} />
  }

  return (
    <AppBannerTertiary
      className={className}
      title={t("screen.article.productBanner.title", "Get {{discount}} off with the Bounce app", {
        discount: formatWholeStripeAmount(500, DEFAULT_CURRENCY, i18n.language),
      })}
      subtitle={t(
        "screen.article.productBanner.subtitle",
        "Use Bounce to find nearby bag storage in {{numCities}}+ cities worldwide.",
        { numCities },
      )}
    />
  )
}
